module.exports = __webpack_public_path__ + "static/img/goodness1.31016303.png";